import {
  SofReceivingLogItem,
  SofItemDraft,
} from '../../../models/sof-receiving/SofReceivingLogItem.interface';

/**
 * [1:1] Stamps freshly loaded items with the editable-draft `dirty` flag.
 *
 * Historically this rule also auto-checked every item on an "entire order"
 * PO the first time it loaded (`applyAutoCheck`). That's been removed — the
 * picker now always checks what they actually pulled, never what the app
 * guessed. What's left is just the item → draft conversion, plus the
 * original guard's effect falls out for free: because nothing here ever sets
 * `checkedOut`, a PO with already-checked items is left exactly as loaded,
 * same as an untouched one.
 *
 * @param items - The items as loaded from the API.
 * @returns A new array of editable item rows, `checkedOut` untouched and
 *   `dirty: false` (nothing has been edited yet).
 */
export function toItemDrafts(items: SofReceivingLogItem[]): SofItemDraft[] {
  return items.map((item) => ({ ...item, dirty: false }));
}
